import "core-js/modules/web.dom.iterable";

//
//
//
//
//
//
//
//
//
//
//
//
//
const NoveltyDecoration = () => import(
/* webpackChunkName: "product-experiment", webpackMode: "eager" */
'~/components/atoms/Product/Decorations/NoveltyDecoration.vue');

const SchoolCharityDecoration = () => import(
/* webpackChunkName: "product-experiment", webpackMode: "eager" */
'~/components/atoms/Product/Decorations/SchoolCharityDecoration.vue');

const FreeDeliveryDecoration = () => import(
/* webpackChunkName: "product-experiment", webpackMode: "eager" */
'~/components/atoms/Product/Decorations/FreeDeliveryDecoration.vue');

const StickerDecoration = () => import(
/* webpackChunkName: "product-experiment", webpackMode: "eager" */
'~/components/atoms/Product/Decorations/StickerDecoration.vue');

export default {
  components: {
    NoveltyDecoration,
    SchoolCharityDecoration,
    FreeDeliveryDecoration,
    StickerDecoration
  },
  props: {
    isNew: {
      type: Boolean,
      default: false
    },
    isSchool: {
      type: Boolean,
      default: false
    },
    deliveryPromotion: {
      type: Object,
      default: null
    },
    trendSticker: {
      type: Array,

      default() {
        return [];
      }

    }
  },
  computed: {
    decorations() {
      const hasDeliveryPromotion = this.deliveryPromotion.alt && this.deliveryPromotion.alt.trim();
      const [trend] = this.trendSticker ? Object.values(this.trendSticker) : [];
      const decorations = [];

      if (hasDeliveryPromotion) {
        decorations.push({
          tag: 'free-delivery-decoration',
          props: {
            label: this.deliveryPromotion.alt
          }
        });
      } else if (this.isNew) {
        decorations.push({
          tag: 'novelty-decoration',
          props: {}
        });
      }

      if (this.isSchool) {
        decorations.push({
          tag: 'school-charity-decoration',
          props: {}
        });
      } else if (trend) {
        decorations.push({
          tag: 'sticker-decoration',
          props: {
            trend
          }
        });
      }

      return decorations;
    }

  }
};